import React from 'react'
import Header from '../components/Header/Header'
import About from '../components/About/About'

const Homepage = () => {
    return (
        <div>
            <Header />
            <About />
        </div>
    )
}

export default Homepage
